import { render, staticRenderFns } from "./viewCustomer.vue?vue&type=template&id=f715a3da&lang=html"
import script from "./viewCustomer.vue?vue&type=script&lang=js"
export * from "./viewCustomer.vue?vue&type=script&lang=js"
import style0 from "./viewCustomer.vue?vue&type=style&index=0&id=f715a3da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports